<template>
    <div class="step-contact-component">
        <div class="row">
            <div class="col-xs-12">
                <job />
                <h2>Kommunikationsdaten</h2>
                <div class="form-container">
                    <form class="contact-form" autocomplete="off">
                        <div class="form-inner">
                            <div class="row">
                                <div class="col-xs-12">
                                    <v-input v-model="formData.email" name="email" label="E-Mail *" validate="required|email" />
                                </div>

                                <div class="col-xs-12">
                                    <v-input v-model="formData.email_repeat" name="email_repeat" label="Mail wiederholen *" validate="required" />
                                </div>

                                <div style="margin-bottom: 55px;" class="col-xs-12">
                                    <h2 style="margin-bottom: 15px;">Telefon *</h2>
                                    <i class="fa fa-info-circle"></i>
                                    <div class="info-text">Bitte füllen Sie mindestens ein Feld zur Telefonnummer aus. Die angegebenen Daten müssen unbedingt korrekt sein, damit wir Sie kontaktieren können.</div>
                                    <div class="clearfix"></div>
                                </div>

                                <div class="col-xs-12">
                                    <v-input v-model="formData.phone" name="phone" label="Festnetz" :validate="phoneRequired" />
                                </div>

                                <div class="col-xs-12">
                                    <v-input v-model="formData.mobilephone" name="mobilephone" label="Mobil" :validate="mobilephoneRequired" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-md-6 col-md-push-6">
                                <div @click="$emit('submit', formData)" class="btn btn-green btn-big submit">weiter</div>
                            </div>

                            <div class="col-xs-12 col-md-6 col-md-pull-8">
                                <div @click="$emit('back')" class="btn btn-transparent btn-big back"><i class="fa fa-chevron-left"></i> zurück</div>
                            </div>

                            <div class="col-xs-12">
                                <p class="notice">Mit * markierte Felder sind Pflichtfelder.</p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VInput from './v-input';
import Job from './job';

export default {
    inject: ['$validator'],
    computed: {
        formData() {
            return this.$store.state.stepContactData;
        },
        phoneRequired() {
            if (this.formData.mobilephone) {
                return '';
            }
            return 'required';
        },
        mobilephoneRequired() {
            if (this.formData.phone) {
                return '';
            }
            return 'required';
        },
    },
    components: {
        VInput,
        Job,
    },
}
</script>

<style lang="scss">
.step-contact-component {
    .fa-info-circle {
        position: relative;
        top: 2px;
        float: left;
        margin-left: 5px;
        font-size: 16px;
    }

    .info-text {
        padding-left: 30px;
    }
}
</style>
